<script lang="ts">
    import TemplateSettingsGeneral from "./TemplateSettingsGeneral.svelte";
    import {_} from 'svelte-i18n';
    import {customerSettings} from '../../../stores/api';
    import SettingsRowDuration from "./SettingsRowDuration.svelte";
    import {z} from "zod";

    export let update: () => void;
    export let asSeconds: boolean = false;

    let max = 60;

    let serviceTimes = {
        each_stop_minutes: $customerSettings.each_stop_minutes,
        each_delivery_minutes: $customerSettings.each_delivery_minutes,
        each_warehouse_delivery_minutes: $customerSettings.each_warehouse_delivery_minutes,
    }

    function onUpdate() {
        for (let i in serviceTimes) {
            $customerSettings[i] = serviceTimes[i];
        }
        update();
    }

    function validator(data: unknown) {
        return z.coerce.number().min(0).max(max).safeParse(data);
    }

</script>


<TemplateSettingsGeneral>
    <div slot="label">{$_('Service time')}</div>
    <div slot="content">
        <SettingsRowDuration label={$_('Each stop')} {max} bind:value={serviceTimes.each_stop_minutes} update={onUpdate} {validator} />
        <SettingsRowDuration label={$_('Each item')} {max} bind:value={serviceTimes.each_delivery_minutes} update={onUpdate} {validator} />
        <SettingsRowDuration label={$_('Each item at warehouse')} {max} bind:value={serviceTimes.each_warehouse_delivery_minutes} update={onUpdate} {validator} />
    </div>
</TemplateSettingsGeneral>
